import {
    GET_ACCOUNT_STATEMENT_REPORT_PROGRESS, GET_ACCOUNT_STATEMENT_REPORT_SUCCESS, GET_ACCOUNT_STATEMENT_REPORT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    accountStatement: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const account_statement_report_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ACCOUNT_STATEMENT_REPORT_SUCCESS:
            return { ...state, accountStatement: action.accountStatement, loading: false };
        case GET_ACCOUNT_STATEMENT_REPORT_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_ACCOUNT_STATEMENT_REPORT_PROGRESS:
            return { ...state, loading: true, error: false };
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message
        default:
            return state
    }
}

export default account_statement_report_reducer;